export class ApiError extends Error {
  constructor(message, data = null) {
    super(message);
    this.name = "ApiError";
    this.data = data;
  }
}

export function unwrapApiResponse(response) {
  const body = response.data;

  if (!body?.status) {
    throw new ApiError(body?.message || "خطایی رخ داد", body);
  }

  return body.data;
}

export function unwrapApiResult(response) {
  const body = response.data;

  if (!body?.status) {
    throw new ApiError(body?.message || "خطایی رخ داد", body);
  }

  return {
    data: body.data,
    message: typeof body.message === "string" ? body.message : "",
  };
}

function readMessageFromBinary(data) {
  if (!data || typeof data.message === "string") {
    return data?.message || null;
  }

  try {
    const buffer =
      data instanceof ArrayBuffer
        ? data
        : ArrayBuffer.isView(data)
          ? data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength)
          : null;

    if (!buffer) {
      return null;
    }

    return JSON.parse(new TextDecoder().decode(buffer))?.message || null;
  } catch {
    return null;
  }
}

export function getErrorMessage(error, fallback = "خطایی رخ داد") {
  if (error instanceof ApiError) {
    return error.message;
  }

  const message =
    error?.response?.data?.message || readMessageFromBinary(error?.response?.data);
  if (message) {
    return message;
  }

  if (error?.message === "Network Error") {
    return "ارتباط با سرور برقرار نشد";
  }

  if (error?.message && !error.message.startsWith("Request failed")) {
    return error.message;
  }

  return fallback;
}
